module.exports = __webpack_public_path__ + "img/gb-wls.623e9fc3.svg";